// removed by extract-text-webpack-plugin
module.exports = {"direct-button-link":"direct-button-link__3wgds","arrow":"arrow__YDWj4"};


//////////////////
// WEBPACK FOOTER
// ./components/button/styles/DirectButtonLink.scss
// module id = SlhJ
// module chunks = 1